import { trackEvent } from '../../lib/tracking';
import type { UtmParams } from '../../types';

interface Props {
  name: string;
  whatsapp: string;
  userName: string;
  startTime: string;
  utmParams: UtmParams;
}

export function MentorCard({ name, whatsapp, userName, startTime, utmParams }: Props) {
  const formattedDate = new Date(startTime).toLocaleString('es-ES', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit',
  });

  const message = `Hola ${name}, soy ${userName}. Tengo agendada mi sesión HIT el ${formattedDate}. Quería confirmarte que estaré presente.`;
  const cleanPhone = whatsapp.replace(/[^\d]/g, '');

  const handleClick = () => {
    trackEvent('Contact', {
      event_category: 'mentor_whatsapp',
      mentor_name: name,
      ...utmParams,
    });
  };

  return (
    <div className="hit-card mb-4">
      <h3 className="text-sm font-extrabold uppercase tracking-widest text-hit-gray-dark mb-4">
        👤 Tu Mentor Asignado
      </h3>

      <p className="font-bold text-hit-black text-lg">{name || 'Tu Mentor HIT'}</p>
      <p className="text-hit-gray-dark text-sm mb-4">Mentor HIT</p>

      {cleanPhone && (
        <a
          href={`https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick}
          className="flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-lg px-4 py-3 transition-colors text-sm"
        >
          💬 Hablar con tu Mentor por WhatsApp
        </a>
      )}
    </div>
  );
}
